<script>
import AoikumoDisabledTooltip from 'dashboard/components/dahreply/AoikumoDisabledTooltip.vue';
import AoikumoOutletTag from 'dashboard/components/dahreply/AoikumoOutletTag.vue';

export default {
  name: 'BranchTable',
  components: {
    AoikumoDisabledTooltip,
    AoikumoOutletTag,
  },
  props: {
    branches: {
      type: Array,
      required: true,
      default: () => [],
    },
    loadingStates: {
      type: Object,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit', 'delete', 'navigate'],
  methods: {
    isLocked(branch) {
      return (
        this.readOnly ||
        this.$store.getters['aoikumo/isLinkedBranch'](branch)
      );
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>

<template>
  <div class="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm">
    <table class="min-w-full text-sm">
      <thead
        class="bg-slate-50 dark:bg-slate-700/50 text-left text-slate-600 dark:text-slate-300 uppercase text-xs font-semibold"
      >
        <tr>
          <th class="px-4 py-3">Branch Name</th>
          <th class="px-4 py-3">Phone Number</th>
          <th class="px-4 py-3">Address</th>
          <th class="px-4 py-3 text-right">Actions</th>
        </tr>
      </thead>

      <tbody>
        <!-- Empty State -->
        <tr v-if="!branches.length">
          <td colspan="6" class="text-center py-6 text-slate-500 dark:text-slate-400">
            No branches found.
          </td>
        </tr>

        <!-- Rows -->
        <tr
          v-for="branch in branches"
          :key="branch.branch.branch_id"
          class="border-t border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/40 transition-colors"
        >
          <td class="px-4 py-3 font-medium text-slate-800 dark:text-slate-200">
            {{ branch.branch.name }}
            <AoikumoOutletTag :branch="branch.branch" class="ml-2" />
          </td>
          <td class="px-4 py-3">{{ branch.branch.phone_number || '-' }}</td>
          <td class="px-4 py-3">{{ branch.branch.address || '-' }}</td>

          <td class="px-4 py-3 text-right flex justify-end gap-2">
            <AoikumoDisabledTooltip :disabled="isLocked(branch.branch)" class="inline-flex gap-2">
              <woot-button
                size="small"
                variant="smooth"
                color-scheme="secondary"
                icon="edit"
                :is-disabled="isLocked(branch.branch)"
                :loading="loadingStates[branch.branch.branch_id]"
                @click="$emit('edit', branch.branch)"
              />
              <woot-button
                size="small"
                variant="smooth"
                color-scheme="alert"
                icon="delete"
                :is-disabled="isLocked(branch.branch)"
                :loading="loadingStates[branch.branch.branch_id]"
                @click="$emit('delete', branch.branch)"
              />
            </AoikumoDisabledTooltip>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
